export const CLASS_NAME = 'cst-icon-export'
